import { InventoryIcon, NAVIGATION_ICON_SIZE } from './icons';
import { Ref } from 'react';
import { Badge } from '@mui/material';

export type NavigationCount = {
  result: number;
  total: number;
  incomplete: boolean;
};

export type AppTab = 'items' | 'locations';
export type ItemActivity = { count: number; failed: number };
export type NavigationProps = {
  value: AppTab;
  onChange: (value: AppTab) => void;
  itemActivity?: ItemActivity;
  onMore?: () => void;
  moreOpen?: boolean;
  moreButtonRef?: Ref<HTMLButtonElement>;
};

export function inventoryActivityLabel(activity?: ItemActivity) {
  return activity?.count
    ? `Inventory, ${activity.count} captured ${activity.count === 1 ? 'item' : 'items'} ${
        activity.failed
          ? activity.count === 1
            ? 'needs attention'
            : 'need attention'
          : 'processing'
      }`
    : 'Inventory';
}

export function InventoryActivityIcon({
  activity,
}: {
  activity?: ItemActivity;
}) {
  return (
    <Badge
      color={activity?.failed ? 'warning' : 'primary'}
      badgeContent={activity?.count || 0}
      invisible={!activity?.count}
      max={99}
    >
      <InventoryIcon sx={{ fontSize: NAVIGATION_ICON_SIZE }} />
    </Badge>
  );
}
